import { STORAGE_KEYS, removeStoredItem } from '@/lib/utils/storage';

/**
 * 現在のセッションを破棄して指定パスへフル遷移する(ログアウト・デモ離脱の共通処理)。
 *
 * 認証 token は httpOnly Cookie のためクライアントからは消せない。サーバの
 * /auth/logout で Cookie を破棄し、localStorage もクリアしてから window.location で
 * フル遷移する(router.push だと Cookie 破棄が反映される前に middleware が走り、
 * /login が /projects に差し戻されてログアウトできないため)。
 */
export async function clearSessionAndRedirect(target: string): Promise<void> {
  try {
    await fetch(`${process.env.NEXT_PUBLIC_API_URL}/auth/logout`, {
      method: 'POST',
      credentials: 'include',
    });
  } catch {
    // ログアウトに失敗しても遷移は続行する
  }
  removeStoredItem(STORAGE_KEYS.TOKEN);
  removeStoredItem(STORAGE_KEYS.ORGANIZATION_ID);
  removeStoredItem(STORAGE_KEYS.USER_ID);
  removeStoredItem(STORAGE_KEYS.ROLE_ID);
  window.location.href = target;
}
